<template>
    <h5>Alta de Tipster</h5>

    
    <Form  role="form"  class="text-start mt-4"  @submit="handleAltaTipster">
 
        <soft-field id="nombre" type="text" :useLabel="true" label="Nombre" name="nombre" v-model="user.nombre" class="mb-2 label-input2" largo="50"/>
        <soft-field id="username" type="text" :useLabel="true" label="Usuario" name="username" v-model="user.username" class="mb-2 label-input2" largo="30"/>
        <soft-field id="contacto" type="text" :useLabel="true" label="Contacto" name="contacto" v-model="user.contacto" class="mb-2 label-input2" largo="80"/>

        <soft-field id="email" type="email" :useLabel="true" label="Email" name="email" v-model="user.email" class="mb-2 label-input2" largo="80"/>

        <!--<soft-field id="telefono" type="tel" :useLabel="true" label="Teléfono" name="telefono" v-model="user.telefono" class="mb-2 label-input2" largo="20"/>-->
        <div class="mb-0 label-input2">
            <label>Teléfono</label>
               <vue-tel-input
                v-model="user.telefono"
                name="telefono"
                default-country="es"
                :only-countries="['es','fr','pt','de','nl','ie','gb','mx','ar','cl','br']"
                :valid-character-only="true"
                :auto-format="false"
                placeholder="Indique teléfono"
                :inputoptions="{ showDialCode: true, placeholder: 'E164' }"
                @input="checkValidPhoneNumber"
                @country-changed="handleCountryChange"
                @blur="checkValidPhoneNumber"
            />
        </div>

        <div v-if="!isValidPhoneNumber" class="error-feedback text-xs text-danger mb-4">
            El teléfono indicado es erróneo
        </div>

        <p class="descripcion">NOTA: El teléfono indicado debe corresponder a un usuario que administre los canales creados</p>

       <QBtn type="submit" variant="tipster" label="Confirmar" :loading="loading" :disabled="loading || !isValidPhoneNumber" class="float-end mt-3" />

    </Form>
  </template>
  
  <script>
  import SoftField from "@/components/SoftField.vue";
  
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  
  import { isValidPhoneNumber } from 'libphonenumber-js';

  export default {
    name: "AltaTipsterForm",
    components: {
        SoftField,
        Form
    },
   data() {
        return {
            loading: false,
            user: {
            nombre: '',
            username: '',
            contacto: '',
            email: '',
            telefono: ''
            },
            isValidPhoneNumber: true
        };
    },
    emits: ['cerrar-modal'],
    methods: {
        blurActiveElement() {
            const el = document.activeElement;
            if (el && typeof el.blur === "function") el.blur();
        },
        onConfirmTouch() {
            // primer tap cierra teclado; no ejecutes lógica aquí
            this.blurActiveElement();
        },
        async handleAltaTipster() {
         
            this.blurActiveElement();
            this.loading = true;
            try {
                const resp = await this.$store.dispatch("auth/guardaTipster", this.user);

                if (resp.res === "OK") {
                showSwal.methods.showSwal({
                    type: "success",
                    message: "Tipster creado. Se envió la contraseña al email indicado.",
                    width: 650,
                });
                this.$emit("cerrar-modal");
                } else {
                showSwal.methods.showSwal({
                    type: "error",
                    message: resp.mensaje,
                    width: 550,
                });
                }
            } catch (e) {
                showSwal.methods.showSwal({
                type: "error",
                message: "Se ha producido un error",
                width: 500,
                });
            } finally {
                this.loading = false;
            }
        },
        checkValidPhoneNumber() {
            const raw = this.user.telefono;
            const tel = (typeof raw === "string") ? raw : (raw?.number || raw?.internationalNumber || "");
            const cleaned = (tel || "").toString().replace(/[()\s-]/g, "");
            this.isValidPhoneNumber = isValidPhoneNumber(cleaned);
        },

        handleCountryChange(countryData) {
            const prefijo = '+' + countryData.dialCode;

            const raw = (this.user.telefono || "").toString();
            if (raw.startsWith(prefijo)) return;

            if (raw.startsWith('+')) {
                const rest = raw.replace(/^\+\d+/, ''); // quita +<digits> del inicio
                this.user.telefono = prefijo + rest;
            } else {
                this.user.telefono = prefijo + raw;
            }

            this.checkValidPhoneNumber();
        },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos específicos del componente MyForm */
  </style>